import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import infoIcon from '../images/info/black.svg';
import {
  gAChangePPConfirmationComponent,
  gAChangePPConfirmationComponentReselectPackageLimited,
  gAChangePPConfirmationComponentReselectPackage,
} from '../reports/gaReports';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import { dwhConfirmationPageDisplay, dwhShowCurrentPackageClick } from '../reports/dwhReports';
import { convertDateTimeToDate } from '../../../../utilities/StringHelpers/StringHelpers';
const ConfirmationComponent = ({ activateSelecting, account, limited, showCurrentPackage, isFromPackage, pageTitle, loginData, displayPackagesLinkTxt }) => {
  //dwh params
  const newOfferId = account.newPackage?.offerID;
  const currentOfferId = account.pricePlan;
  const subscriber = loginData?.userDetails.contactNumber;
  const pageURL = window.location.href;
  const customerName = `${loginData?.userDetails?.firstName} ${loginData?.userDetails?.lastName}`;
  const id = loginData?.userDetails?.IDNumber;
  const phoneNumber = account.subscriberNo;
  useState(() => {
    //GA old
    gAChangePPConfirmationComponent();

    //GA 4
    if (!isFromPackage) {
      gtag4({
        event: 'CellPackUpdateP2_Step9_PackageExistsPage',
        step: '9',
        title: pageTitle,
        action: 'PackageExistsPage',
        package: account?.newPackage?.title?.replace(/<\/?[^>]+(>|$)/g, ''),
      });
    } else {
      gtag4({
        event: 'CellPackUpdateP1_Step6_PackageExistsPage',
        step: '6',
        action: 'PackageExistsPage',
        title: pageTitle,
        package: account?.newPackage?.title?.replace(/<\/?[^>]+(>|$)/g, ''),
      });
    }

    //DWH
    dwhConfirmationPageDisplay({ newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber });
  }, []);

  const reActivateSelecting = () => {
    if (limited) {
      gAChangePPConfirmationComponentReselectPackageLimited();
    } else {
      gAChangePPConfirmationComponentReselectPackage();
    }

    if (!isFromPackage) {
      gtag4({
        event: 'CellPackUpdateP2_Step12_ChangePackageButton',
        button: 'שינוי החבילה',
        step: '12',
        package: account.newPackage?.title,
        title: pageTitle,
        action: 'ChangePackageButton',
      });
    } else {
      gtag4({
        event: 'CellPackUpdateP1_Step9_ChangePackageButton',
        button: 'שינוי החבילה',
        step: '9',
        package: account.newPackage?.title,
        title: pageTitle,
        action: 'ChangePackageButton',
      });
    }
    activateSelecting(account);
  };

  const gaShowCurrentPackage = () => {
    if (!isFromPackage) {
      gtag4({
        event: 'CellPackUpdateP2_Step10_PackageExistsInfoButton',
        button: 'לצפיה בחבילה הקיימת',
        step: '10',
        package: account.newPackage?.title,
        title: pageTitle,
        action: 'PackageExistsInfoButton',
      });
    } else {
      gtag4({
        event: 'CellPackUpdateP1_Step7_PackageExistsInfoButton',
        button: 'לצפיה בחבילה הקיימת',
        step: '7',
        package: account.newPackage?.title,
        title: pageTitle,
        action: 'PackageExistsInfoButton',
      });
    }
    //DWH
    dwhShowCurrentPackageClick({ newOfferId, currentOfferId, subscriber, pageURL, customerName, id, phoneNumber });
  };

  // const getTomorrowDate = () => {
  //   const tomorrowDate = new Date();
  //   tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  //   return tomorrowDate;
  // };

  return (
    <div className={`confirmation-item`}>
      <div className='confirmation-item-top-box'>
        <div className='subscriber-item-number bold'>מנוי {account.subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2')}</div>
        <div
          className='go-to-current-plan'
          onClick={() => {
            gaShowCurrentPackage(), showCurrentPackage(account.subscriberNo, true);
          }}>
          <span>לצפיה בחבילה הקיימת </span>
        </div>
      </div>

      <div className={`confirmation-item-bottom-box`}>
        <div className={'new-package-price-info-text '}>
          <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M6.293 6.34a.986.986 0 0 1 1.414 0L10 8.68l4.293-4.381a.986.986 0 0 1 1.414 0c.39.398.39 1.044 0 1.443l-5 5.102a.986.986 0 0 1-1.414 0l-3-3.061a1.035 1.035 0 0 1 0-1.443z'
              fill='#757475'
            />
          </svg>
          נבחרה חבילה חדשה
        </div>

        <div dangerouslySetInnerHTML={{ __html: account.newPackage?.title }} className='bold newPackage-title' />

        <div className='new-package-price-info'>
          <span className='bold'>₪{account.newPackage?.price}&nbsp;</span>לחודש
        </div>
        {account.newPackage?.oneTimeFee ? (
          <div className='new-package-price-info'>
            <span className='bold'>₪{account.newPackage?.oneTimeFee}&nbsp;</span>דמי מעבר חד פעמי
          </div>
        ) : (
          <div className='new-package-price-info'>ללא דמי מעבר</div>
        )}
        <div className='bill-cicle'>
          <Image src={infoIcon} />
          {
            account.newPackage?.isImmediateTransitionPlan ? (
              <span> החבילה תיכנס לתוקף החל מהיום {convertDateTimeToDate(new Date())} </span>
            ) : (
              <span> החבילה תותקן במחזור חיוב הבא {account.billCycle} </span>
            )
          }
        </div>
        <div
          className='new-package-button'
          onClick={reActivateSelecting}>
          <span>{displayPackagesLinkTxt}</span>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationComponent;
